export const scrollIntoView = (id) => {
  document.querySelector(id).scrollIntoView();
};
